import React, { useEffect, useState } from "react";
import { PaymentMode } from "../../../constants/payment.const";
import Loading from "../../../loading";
import styles from "./index.module.scss";
import OpenEdgeSelection from "../../sections/PaymentMethods/OpenEdgeSelection";
import { FormControlLabel, Radio, Grid, RadioGroup } from "@material-ui/core";
import StyleConfig from "../../../StyleConfig";
import StaxPaymentSelection from "../../sections/stax/StaxPaymentSelection";
import CybersourceSelection from "../../sections/cybersource/Cybersource";

interface IPaymentAccountProps {
  companyId: string | null;
  masterId: string | null;
  data: any;
}

export const PaymentAccount: React.FC<IPaymentAccountProps> = ({
  companyId,
  masterId,
  data,
}) => {
  const [paymentMode, setPaymentMode] = useState("OPENEDGE");
  const [loading, setLoading] = useState<boolean>(false);
  const styleConfig = new StyleConfig();
  const classes = styleConfig.paymentDetails();

  useEffect(() => {
    setPaymentMode(data?.paymentGateway);
  }, [data]);

  return (
    <section className="manage-branding-container">
      <div className="box-shadow  custom-card-manage-branding">
        <Grid container direction="row">
          <span className="title-label-branding">Payment Mode</span>
        </Grid>
        {loading ? (
          <Loading />
        ) : (
          <div className="grid-margin-brand">
            <div className={styles.section}>
              <RadioGroup
                row
                aria-label={"Payment Method"}
                name={"Payment Method"}
                value={paymentMode}
                onChange={(e) => {
                  setPaymentMode(e.currentTarget.value);
                }}
              >
                <FormControlLabel
                  value={PaymentMode.OPEN_EDGE}
                  classes={{ label: classes.label }}
                  control={
                    <Radio
                      color="default"
                      classes={{
                        root: classes.RadioCheckButtonColor,
                        checked: classes.RadioCheckButtonColor,
                      }}
                    />
                  }
                  label="OpenEdge"
                />
                <FormControlLabel
                  value={PaymentMode.STAX}
                  classes={{ label: classes.label }}
                  control={
                    <Radio
                      color="default"
                      classes={{
                        root: classes.RadioCheckButtonColor,
                        checked: classes.RadioCheckButtonColor,
                      }}
                    />
                  }
                  label="Successware Payments"
                />
                <FormControlLabel
                  value={PaymentMode.CYBERSOURCE}
                  classes={{ label: classes.label }}
                  control={
                    <Radio
                      color="default"
                      classes={{
                        root: classes.RadioCheckButtonColor,
                        checked: classes.RadioCheckButtonColor,
                      }}
                    />
                  }
                  label="Cybersource"
                />
              </RadioGroup>
            </div>
            {paymentMode === PaymentMode.OPEN_EDGE && (
              <section className="enable-success-pay-container">
                <OpenEdgeSelection
                  type="card"
                  companyID={companyId}
                  setLoading={setLoading}
                  data={data.ccPaymentDetail}
                  masterID={masterId}
                />
                <OpenEdgeSelection
                  type="ach"
                  companyID={companyId}
                  setLoading={setLoading}
                  data={data.achPaymentDetail}
                  masterID={masterId}
                />
              </section>
            )}
            {paymentMode === PaymentMode.STAX && (
              <section className="enable-success-pay-container">
                <StaxPaymentSelection
                  type="ach"
                  companyID={companyId}
                  setLoading={setLoading}
                  data={data.achPaymentDetail}
                  masterID={masterId}
                />
              </section>
            )}
            {paymentMode === PaymentMode.CYBERSOURCE && (
              <section className="enable-success-pay-container">
                <CybersourceSelection
                  type="ach"
                  companyID={companyId}
                  setLoading={setLoading}
                  data={data.achPaymentDetail}
                  masterID={masterId}
                />
              </section>
            )}
          </div>
        )}
      </div>
    </section>
  );
};
